import { arrayOf, objectOf } from "@altostra/type-validations";
import { any } from "@altostra/type-validations/lib/primitives";

export const isPostReportingAppGroupIdMetricsQueryResult = objectOf({
  data: arrayOf(any),
});
